interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'success';
}

export function Button({ variant = 'primary', className = '', ...props }: ButtonProps) {
  const base = 'rounded-lg py-2.5 px-4 text-sm font-semibold transition-colors disabled:opacity-50';
  const variants = {
    primary: 'bg-blue-500 hover:bg-blue-600 text-white',
    secondary: 'bg-slate-700 hover:bg-slate-600 text-slate-300',
    success: 'bg-emerald-600 hover:bg-emerald-700 text-white',
  };
  return <button className={`${base} ${variants[variant]} ${className}`} {...props} />;
}
